//* 组件库
import type { UiTypes, UiTableOption2 } from "various-ui";

export const useOptions = () => {
    const i18n = useI18n();

    const seletcor: UiTypes.candidate[] = [
        { label: i18n.t("All"), value: "" },
        { label: i18n.t("Human", 2), value: "9606" },
        { label: i18n.t("Mouse", 2), value: "10090" },
        { label: i18n.t("Rat", 2), value: "10116" },
    ];

    //* 表格配置项
    const table: UiTableOption2[] = [
        { key: "id", name: "NCBI", align: "singularity" },
        { key: "gene_name", name: i18n.t("Gene"), align: "singularity" },
        { key: "gene_full_name", name: i18n.t("GeneFullName"), align: "singularity" },
        { key: "source", name: i18n.t("Species"), align: "singularity" },
        { key: "alias", name: i18n.t("Alias"), align: "singularity" },
    ];

    return {
        seletcor,
        table,
    };
};
